export default __webpack_public_path__ + "static/media/1.74fe0a98.png";